import {
  userDataResetLoaderAction,
  userDataChangeAction
} from '../../actions/UserData';
import {
  callCreateCustomerService,
  activationDateBaseModel,
  callPurchaseService,
  portratiLeadAction,
  checkBankAccountDetails
} from './common';
import { carServiceV2 } from './carV2';
import { travelService } from './travel';
import { householdService } from './household';
import { consentService } from './consent';
import { leadService } from './leadGeneration';
import { personalService } from './personal';
import { tjmService } from './tjmService';
import { finaCombinedCall } from './FinaCombinedCall';

/**
 * Handler for calling services supported.
 * @param  {string}   service     The service to call.
 * @param  {Object}   params      Params needed in the service.
 * @param  {string}   forProduct  Only run if the product is in the basketlist.
 * @param  {Object}   formValues  The current forms values.
 * @param  {Function} dispatch    Dispatch function from the store.
 * @return {Promise}              The promise from the called service.
 */
export const callService = (service, params, forProduct, formValues, dispatch, actionOnErrors) => {
  const values = formValues;
  if ( forProduct && forProduct !== '') {
    values["forProduct"] = forProduct;
  }
  dispatch(userDataChangeAction({
    fields: [{
      field: "forProduct",
      value: forProduct,
    }]
  }));
  switch (service) {
    
    case 'createCustomerV2':
      return dispatch(carServiceV2.createCustomerV2(params, formValues));

    case 'createCustomer':
      return callCreateCustomerService(params, formValues, dispatch);

    case 'getActivationDate':
      return dispatch(carServiceV2.activationDateGetActionService(values,
        activationDateBaseModel(values), params));

    case 'getActivationDates':
      return carServiceV2.getActivationDatesService(formValues,
        activationDateBaseModel(formValues), dispatch);

    case 'getActivationDatesMonthYear':
      return carServiceV2.getActivationDatesMonthYearService(formValues,
        activationDateBaseModel(formValues));

    case 'purchase':
      return callPurchaseService(params, formValues, dispatch);

    case 'purchase_V2':
      return dispatch(carServiceV2.purchase(params, formValues));

    case 'tjmPayment':
      return dispatch(tjmService.tjmPayment(params, formValues));
    
    case 'tjmPaymentType':
      return dispatch(tjmService.paymentType(params, formValues));

    case 'resetLoader':
      return dispatch(userDataResetLoaderAction());

    case 'createPortraitLead':
      return dispatch(portratiLeadAction(params, formValues));

    case 'travelCreateUpdate':
      return dispatch(travelService.createUpdateTravelAction(params, actionOnErrors, formValues));

    case 'travelGetPriceAuxService':
      return dispatch(travelService.createGetPriceAuxServiceTravel(params, formValues));

    case 'travelExcessAmount':
      return travelService.getExcessAmount(formValues, dispatch);

    case 'travelPreparePurchase':
      return dispatch(travelService.prepareTravelAction(params, formValues));

    case 'travelPurchase':
      return dispatch(travelService.purchase(params, formValues));

    case 'travelCreateCustomer':
      return dispatch(travelService.createCustomerV2(params, formValues));

    case 'householdCreateUpdate':
      return dispatch(householdService.createUpdateHouseholdAction(params, actionOnErrors,
        formValues));

    case 'householdGetAuxValues':
      return dispatch(householdService.returnPriceAuxAction(params, formValues));

    case 'householdGetAddressDetailsValues':
      return dispatch(householdService.returnHouseholdAddressDetailsAction(params, formValues));

    case 'householdCreateCustomer':
      return dispatch(householdService.createCustomerV2(params, formValues));

    case 'householdPurchase':
      return dispatch(householdService.purchase(params, formValues));

    case 'consentsService':
      return dispatch(consentService.updateConsentsService(params, formValues));

    case 'consentGPCService':
      return dispatch(consentService.putGPCService());

    case 'generateLead':
      return dispatch(leadService.createLead(params, formValues));

    case 'getPersonalPrice':
      return dispatch(personalService.createUpdatePersonalAction(params, actionOnErrors, formValues));
  
    case 'personalCreateCustomer':
      return dispatch(personalService.createCustomerV2(params, formValues));

    case 'personalPurchase':
      return dispatch(personalService.purchase(params, formValues));

    case 'checkBankAccountDetailsService':
      return dispatch(checkBankAccountDetails(formValues));

    case 'finaCombinedServices':
      return dispatch(finaCombinedCall.combinedCalls(formValues, dispatch));

    case 'combinedCusPurchase':
      return dispatch(finaCombinedCall.combinedCusPurchase(undefined,formValues, dispatch));

    case 'getConsentTypes':
      return dispatch(consentService.getConsentTypesNoArgsService());
  
    default:
      return Promise.resolve();
  }
};